import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import loadable from '@loadable/component'

import "../css/Header.css";
import { UserSession } from "../modules/UserSession";
import { useSelector } from "react-redux";
import $ from "jquery";

export default function SMLSLoginModal(props) {

  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);

  const [userName, setUserName] = useState(null);
  const [password, setPassword] = useState(null);
  const seeMyLoanFormDataRedux = useSelector((state) => state.nameReducer.seeMyLoanFormData);
  const [pricingData, setPricingData] = useState(
    seeMyLoanFormDataRedux && Object.keys(seeMyLoanFormDataRedux).length !== 0 ? seeMyLoanFormDataRedux : {})

  function serialize(form) {
    let inputs = form.elements;
    let testArray = {};
    for (let i = 0; i < inputs.length - 1; i++) {
      testArray[inputs[i].id] = inputs[i].value;
    }
    return testArray;
  }

  function postInput(id, val) {
    return (
      '<input style="display:none" type="text" name="' +
      id +
      '" value="' +
      val +
      '" />'
    );
  }

  const userSession = new UserSession();
  /** WHL-41: function to append pricing data, if sent  */
  const appendPricingData = () => {

    if(pricingData && Object.keys(pricingData).length !== 0){

      const {
        loanAmount,
        downPayment,
        cashOutAmount,
        fico,
        propertyZipCode,
        propertyState,
        propertyCountyCode,
        propertyTypeKeyword,
        occupancy,
        productCode,
        optionKeyword,
        loanPurposeKeyword,
        rate
      } = pricingData

      const cashOutData = userSession.getCashOutAmount() ? userSession.getCashOutAmount() : ''
      const appraisedValue = userSession.getEstimatedValue() ? userSession.getEstimatedValue() : ''

      let newLoanAmount = loanAmount
      if (
        (
          (userSession.getLoanPurposeCode() === 'PURCHASE') ||
          (userSession.getLoanPurposeCode() === 'PURCHASE REHAB') /** WHL-41: 203k may send this type of value */
        ) &&
        downPayment &&
        (parseInt(downPayment) > 0)
      ) newLoanAmount += downPayment 

      let newData = postInput("extLoanAmount", newLoanAmount) +
        postInput("extDownPayment", downPayment) +
        // postInput("extAppraisalAmount ", 0) +
        postInput("extCashOutAmount", cashOutData) +
        postInput("extCreditScore", fico) +
        postInput("extPropertyZip", propertyZipCode) +
        postInput("extPropertyState", propertyState) +
        postInput("extPropertyCounty", propertyCountyCode) +
        postInput("extPropertyType", propertyTypeKeyword) +
        postInput("extPropertyOccupancy", occupancy) +
        postInput("extProductCode", typeof productCode !== 'undefined' ? productCode : '') +
        postInput("extFhaSection", typeof optionKeyword !== 'undefined' ? optionKeyword : '') +
        postInput("extLoanPurpose", loanPurposeKeyword) + 
        postInput("extRate", rate) 

        if(
          (
            (userSession.getLoanPurposeCode() !== 'PURCHASE') &&
            (userSession.getLoanPurposeCode() !== 'PURCHASE REHAB') /** WHL-41: 203k may send this type of value */
          ) &&
          appraisedValue
        ) {
          newData += postInput("extAppraisalAmount", appraisedValue)
        }

      return newData
    } else return ''
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setFormLoading(true);
  
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      setFormLoading(false);
    } else {
      setValidated(false);
      const url = process.env.REACT_APP_SMLS_LOGIN_URL;
      const newData = appendPricingData();
  
      // Create a new hidden form dynamically
      const newForm = document.createElement("form");
      newForm.action = url;
      newForm.method = "POST";
      newForm.target = "_blank"; // Open in new tab
      newForm.style.visibility = "hidden"; // Fully hide the form
  
      // Append hidden input fields
      const formFields = [
        { name: "loginType", value: "originator" },
        { name: "userId", value: userName },
        { name: "password", value: password },
        { name: "action", value: props.actionType },
      ];
  
      // Add pricing data if available
      if (newData) {
        newForm.innerHTML = newData;
      }
  
      formFields.forEach(({ name, value }) => {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = name;
        input.value = value;
        newForm.appendChild(input);
      });
  
      document.body.appendChild(newForm);
  
      // Submit the form
      newForm.submit();
  
      // Remove the form immediately after submission
      setTimeout(() => {
        document.body.removeChild(newForm);
        setFormLoading(false); // Reset loading state
        props.modalClose(); // Close the modal
      }, 0);
    }
  };
  
 
  return (
    <Modal className="input-eye-icon-none aqua-theme-wrapper" show={props.showModal} onHide={props.modalClose}>
      <Modal.Header className="aqua-theme-title-section" closeButton>
        <Modal.Title className="text-content">
          Login 
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          className="need-validation"
          id="frmSMLSLogin"
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
        >
          <Form.Row className="mb-3">
            <Col>
              <Form.Label srOnly>User ID</Form.Label>
              <Form.Control
                type="text"
                name="userName"
                required
                value={userName}
                placeholder="Enter User ID"
                onChange={(e) => {
                  setUserName(e.target.value);
                }}
                onKeyDown = {e => {
                  if(e.key === 'Enter') {
                    handleSubmit(e)
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">
                User ID is required
              </Form.Control.Feedback>
            </Col>
          </Form.Row>
          <Form.Row className="mb-3">
            <Col>
              <Form.Label srOnly>Password</Form.Label>
              <Form.Control
                type="password"
                name="Password"
                placeholder="Enter Password"
                required
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                onKeyDown = {e => {
                  if(e.key === 'Enter') {
                    handleSubmit(e)
                  }
                }}
              />
              <Form.Control.Feedback type="invalid">
                Password is required
              </Form.Control.Feedback>
            </Col>
          </Form.Row>

          <Col className="px-0 pt-1 btnSubmit-Col text-center">
            <Button className="btnSubmit" type="submit">
              {formLoading ? (
                <div className='smlsLoader'><Spinner
                  as="span"
                  animation="border"
                  size="md"
                  role="status"
                  aria-hidden="true"
                /><span>{` Please wait...`}</span></div>
              ) : (
                "Submit"
              )}
            </Button>
          </Col>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
